<template>
  <div class="NumberInputWithButtons">
    <i v-if="icon" class="fa prefix" v-bind:class="[icon]"></i>
    <label v-bind:class="{ disabled: isDisabled }" :for="fname" v-if="label">{{ $t(label) }}</label>
    <div class="input-group">
      <span class="input-group-btn">
        <button class="btn btn-secondary minusBtn" type="button" @click="decrement()">-</button>
      </span>
      <input
        v-on:blur="blur"
        type="number"
        :id="fname"
        class="form-control"
        v-bind:class="{ invalid: errors.length && !untouched }"
        v-model.number="internalValue"
        :disabled="isDisabled"
        :min="min"
        :max="max"
        :step="step"
      />
      <span class="input-group-btn">
        <button
          class="btn btn-secondary plusBtn"
          type="button"
          :disabled="addDisabled"
          @click="increment()"
        >
          +
        </button>
      </span>
    </div>
    <div v-if="explanation && errors.length === 0" class="explanation">
      <small>{{ $t(explanation) }}</small>
    </div>
    <transition name="slidedown">
      <div v-if="errors.length && (!untouched || showAllErrors)" class="validationErrors">
        <small v-for="error in errors" v-bind:key="error">
          {{ $t(error) }}
        </small>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'numberInputWithButtons',
  data() {
    return {
      untouched: true,
    };
  },
  emits: ['input', 'update:modelValue'],
  computed: {
    ...mapState({
      showAllErrors: (state) => state.showAllValidationErrors,
    }),
    isDisabled() {
      if (this.disabled) {
        return true;
      }
      return false;
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.updateValue(v);
      },
    },
  },
  props: {
    fname: { default: '' },
    modelValue: { default: 0 },
    label: { default: '' },
    icon: { default: false },
    explanation: { default: false },
    min: {
      default: 0,
    },
    addDisabled: { default: false },
    step: {
      default: 1,
    },
    max: {
      default: undefined,
    },
    disabled: { default: false },
    errors: {
      default() {
        return [];
      },
    },
  },
  methods: {
    updateValue(value) {
      let newV = value;
      if (Number.isNaN(value)) {
        newV = this.min;
      }
      let v = parseInt(newV, 10);
      if (typeof this.max !== 'undefined') {
        if (v > this.max) {
          v = this.max;
        }
      }
      if (typeof this.min !== 'undefined') {
        if (v < this.min) {
          v = this.min;
        }
      }
      this.$emit('update:modelValue', v);
      this.$emit('input', v);
    },
    increment() {
      this.updateValue(this.modelValue + 1);
    },
    decrement() {
      this.updateValue(this.modelValue - 1);
    },
    blur() {
      this.untouched = false;
      this.$emit('blur');
      this.updateValue(this.modelValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/form';
.NumberInputWithButtons {
  @extend .form-group;
}
input {
  text-align: center;
  min-width: 4em;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  appearance: textfield;
}
</style>
